module.exports = __webpack_public_path__ + "img/france-liver-cancer-male.f792af5c.png";